const FILTER_CLASSES_PREFIX = "filter";

export const FILTER_CLASSES = {
  filterLabel: `${FILTER_CLASSES_PREFIX}-filterLabel`,
  accordionTitleContent: `${FILTER_CLASSES_PREFIX}-accordionTitleContent`,
  labelContainer: `${FILTER_CLASSES_PREFIX}-labelContainer`,
  label: `${FILTER_CLASSES_PREFIX}-label`,
  filterItemsContainer: `${FILTER_CLASSES_PREFIX}-filterItemsContainer`,
  colorTag: `${FILTER_CLASSES_PREFIX}-colorTag`,
  hideOnDesktop: `${FILTER_CLASSES_PREFIX}-hideOnDesktop`,
};
